import lodashGet from 'lodash/get';
import lodashSet from 'lodash/set';
import { DataType } from "./tkr-constants";
import AddressNamesHelper from './address-names-helper';
export const getRefToPropParent = (obj, key) => {
    if (obj && key) {
        const dotIndex = key.lastIndexOf('.');
        if (dotIndex != -1) {
            const parentKey = key.substring(0, dotIndex);
            const currentParent = lodashGet(obj, parentKey);
            if (!currentParent) {
                lodashSet(obj, parentKey, {});
                return lodashGet(obj, parentKey);
            }
            return currentParent;
        }
        else {
            return obj;
        }
    }
    console.log('getRefToPropParent: return undefined', { obj, key });
    return undefined;
};
export const serializeKeyedSelection = (keyedSelections) => {
    let result = '';
    for (const prop in keyedSelections) {
        if (keyedSelections[prop]) {
            result += result ? (',' + prop) : prop;
        }
    }
    return result;
};
export const deserializeKeyedSelection = (value) => {
    const result = {};
    if (value) {
        for (const s of ('' + value).split(',')) {
            if (s)
                result[s] = true;
        }
    }
    return result;
};
export function formatDataFieldValue(value, dataField) {
    var _a;
    switch (dataField === null || dataField === void 0 ? void 0 : dataField.type) {
        case DataType.BOOL:
            return value ? "Kyllä" : "Ei";
        case DataType.INTEGER:
            const iv = parseInt(value);
            return Number.isNaN(iv) ? '' : `${iv} ${dataField.unit}`.trim();
        case DataType.NUMBER:
        case DataType.FORMULA_NUMBER:
            const fv = parseFloat(value);
            return Number.isNaN(fv) ? '' : `${fv.toFixed(dataField === null || dataField === void 0 ? void 0 : dataField.decimals).replace('.', ',')} ${dataField.unit}`.trim();
        case DataType.ADDRESS_NAMES:
            return AddressNamesHelper.stringifyAddressNames(value);
        case DataType.DATE:
            if (value) {
                const dateComponents = value.split('-');
                return `${parseInt(dateComponents[2])}.${parseInt(dateComponents[1])}.${parseInt(dateComponents[0])}`;
            }
            return '';
        case DataType.OPTIONS_LIST:
            if (value && ((_a = dataField.optionsList) === null || _a === void 0 ? void 0 : _a.options)) {
                const resolveOption = (name) => {
                    const opt = dataField.optionsList.options.find(o => o.name === name);
                    return opt ? (opt.title || opt.name) : name;
                };
                if (dataField.optionsList.multiSelect) {
                    return ('' + value).split(',').map(resolveOption).join(', ');
                }
                return resolveOption('' + value);
            }
            return value ? '' + value : '';
        case DataType.STRING:
            return value;
        default:
            return value ? '' + value : '';
    }
}
